// Central async access-token getter for the CMS.
//
// Reads the live token from the Supabase session (persisted + auto-refreshed by
// supabase-js) instead of a stale localStorage mirror. This mirrors the Portal
// pattern (energetic-eternity-web premium-web services/api.ts) and the CMS
// apiService.getAccessToken. Because getSession() is async, every caller must
// `await getAccessToken()`.
import { supabase } from './supabaseClient';

export async function getAccessToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}
